import { Pkt } from '@/features/dashboard/tfg/types/Pkt.ts';

/**
 * Stable ordering of the six TFG rate buckets (pkt 1–6) used to sort the
 * declaration rows so the table always mirrors the official UFG form layout.
 */
export const PKT_ORDER: Pkt[] = [
  Pkt.PKT_1,
  Pkt.PKT_2,
  Pkt.PKT_3,
  Pkt.PKT_4,
  Pkt.PKT_5,
  Pkt.PKT_6,
];

/** 1-based number shown in the left "Pkt" column of the form. */
export const pktNumber: Record<Pkt, number> = {
  [Pkt.PKT_1]: 1,
  [Pkt.PKT_2]: 2,
  [Pkt.PKT_3]: 3,
  [Pkt.PKT_4]: 4,
  [Pkt.PKT_5]: 5,
  [Pkt.PKT_6]: 6,
};

/**
 * Full official wording of each rate bucket, transcribed from the UFG form
 * `.claude/wzór deklaracji TFG od stycznia 2021.pdf` (the backend sends only the
 * raw enum names). The same six descriptions apply to both Dział I and Dział II.
 */
export const pktLabel: Record<Pkt, string> = {
  [Pkt.PKT_1]:
    'Impreza turystyczna na terytorium państw europejskich i pozaeuropejskich z wykorzystaniem transportu lotniczego w ramach przewozu czarterowego',
  [Pkt.PKT_2]:
    'Impreza turystyczna na terytorium państw pozaeuropejskich z wykorzystaniem innego środka transportu niż transport lotniczy w ramach przewozu czarterowego',
  [Pkt.PKT_3]:
    'Impreza turystyczna na terytorium państw europejskich z wykorzystaniem transportu lotniczego w ramach przewozu czarterowego',
  [Pkt.PKT_4]:
    'Impreza turystyczna na terytorium państw europejskich z wykorzystaniem innego środka transportu niż transport lotniczy w ramach przewozu czarterowego',
  [Pkt.PKT_5]:
    'Impreza turystyczna na terytorium krajów mających lądową granicę z Rzecząpospolitą Polską, a w przypadku Federacji Rosyjskiej w obrębie obwodu kaliningradzkiego, oraz na terytorium Rzeczypospolitej Polskiej, z zapewnieniem transportu',
  [Pkt.PKT_6]:
    'Impreza turystyczna na terytorium krajów mających lądową granicę z Rzecząpospolitą Polską, a w przypadku Federacji Rosyjskiej w obrębie obwodu kaliningradzkiego, oraz na terytorium Rzeczypospolitej Polskiej, bez zapewnienia transportu',
};

export const getPktLabel = (pkt: Pkt): string => pktLabel[pkt] ?? pkt;
